import { OnInit, EventEmitter, Input, Output, Component, AfterViewInit } from '@angular/core';

@Component({
    selector: 'gaweb-collapsing-header',
    templateUrl: './collapsing-header.component.html'
})
export class CollapsingHeaderComponent implements OnInit, AfterViewInit {
    @Input() title: string;
    @Input() icon: string;
    @Input() rightIcon: string;
    @Output() onHeaderClicked: EventEmitter<any> = new EventEmitter();
    @Input() loadsExpanded: boolean;
    @Input() headerClass: string;

    @Input() expanded: boolean;

    ngOnInit(): void {
        setTimeout(() => {
            /* if (!this.loadsExpanded) { this.loadsExpanded = false; }*/
            this.expanded = this.loadsExpanded;
            this.onHeaderClicked.emit(this.expanded);
        }, 0);

        
    }

    ngAfterViewInit() {
        setTimeout(() => {
            /* if (!this.loadsExpanded) { this.loadsExpanded = false; }*/
            this.expanded = this.loadsExpanded;
            this.onHeaderClicked.emit(this.expanded);
        }, 0);

    }

    headerClicked() {
        this.expanded = !this.expanded;
        this.onHeaderClicked.emit(this.expanded);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/collapsing-header/collapsing-header.component.ts